import { render } from "./UangKeluarHapusModal.vue?vue&type=template&id=566466dc&scoped=true"
import script from "./UangKeluarHapusModal.vue?vue&type=script&lang=js"
export * from "./UangKeluarHapusModal.vue?vue&type=script&lang=js"

import "./UangKeluarHapusModal.vue?vue&type=style&index=0&id=566466dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-566466dc"

export default script